module.exports = __webpack_public_path__ + "img/speaker.ca1adb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/speaker.png
// module id = U6cE
// module chunks = 0